



































































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbView, mdbMask } from '@folky-tools/mdbvue';
import { usersService, businessBookingOptionsService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessBookingOptions } from '@/models/businesses/business-booking-options';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbView,
        mdbMask,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        EditBookingOptions: () => import('@/components/businesses/EditBookingOptions.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessBookingOptionsView extends Vue {
    private businessBookingOptions: BusinessBookingOptions = new BusinessBookingOptions();
    private businessBookingOptionsCopy: BusinessBookingOptions = new BusinessBookingOptions();

    private showEditBookingOptions: boolean = false;
    private savingBookingOptions: boolean = false;
    private pageContentLoaded: boolean = false;

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessBookingOptionsView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');

        this.businessBookingOptions = await businessBookingOptionsService.getBookingOptions(+this.$route.params.id);
        this.businessBookingOptionsCopy = this.businessBookingOptions.clone();

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.BookingOptions,
                entityId: +this.$route.params.id
            })
        );
        setTimeout(() => {
            this.pageContentLoaded = true;
        }, 10);
    }

    private editBookingOptions(): void {
        this.showEditBookingOptions = true;
    }

    private async saveBookingOptions(): Promise<void> {
        this.savingBookingOptions = true;
        try {
            if (await businessBookingOptionsService.updateBookingOptions(+this.$route.params.id!, this.businessBookingOptions)) {
                this.showEditBookingOptions = false;
                this.businessBookingOptionsCopy = this.businessBookingOptions.clone();

                notificationsService.showToastSuccessNotification('views.businesses.businessBookingOptionsView.notifications.saveBookingOptions.success');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.BookingOptions,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBookingOptions = false;
        }
    }

    private closeBookingOptionsEdition(): void {
        this.businessBookingOptions = this.businessBookingOptionsCopy.clone();
        this.showEditBookingOptions = false;
    }
}
